import React from 'react';
import styled from '@emotion/styled';
import { Accordion, AccordionPanel } from '@/src/components/accordion';
import {
  BlockGroupSelectPanel,
} from './BlockGroupSelectPanel';
import {
  BlockEditor
} from './BlockEditor';
import { useEditorContext } from '@/src/context/EditorContext';

export function SpirtEditor() {
  const {
    options,
    activeBitMapID,
    setActiveBitMapID,
  } = useEditorContext();
  const {
    Container,
    ObjectNavigation,
    Editor,
  } = S;
  return (
    <Container>
      <ObjectNavigation>
        <Accordion defaultActive={BlockGroupSelectPanel.id}>
          <BlockGroupSelectPanel />
          <AccordionPanel id="Map" title="色块地图" />
        </Accordion>
      </ObjectNavigation>
      <Editor>
        {activeBitMapID === undefined ? null : (
          <BlockEditor />
        )}
      </Editor>
    </Container>
  );
}
const S = {
  Container: styled.div`
    display: grid;
    grid-template-columns: 240px auto;
  `,
  ObjectNavigation: styled.div`
  `,
  Editor: styled.div`
    color: #000;
  `,
}
